module.exports = __webpack_public_path__ + "images/花筑村全景_06-3.jpg?v=b88a9bc9";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-3.jpg
 ** module id = 95
 ** module chunks = 1 2
 **/